module.exports = __webpack_public_path__ + "static/fonts/Helvetica.a357d33c.ttf";